import { useCallback, useState } from 'react';

import { validateAddress, VALIDATED_ADDRESS_STATUS } from '../address/address-validation.api';

import type { AddressValidationResultItem, ValidateAddressRequest } from '../address/address-validation.api';

const networkErrorResult: AddressValidationResultItem = {
  status: VALIDATED_ADDRESS_STATUS.ERROR,
  messages: [],
  matchedAddress: null,
  originalAddress: null,
  validationMessages: [],
};

export const useAddressValidation = (initialResult: AddressValidationResultItem | null = null) => {
  const [validationResult, setValidationResult] = useState<AddressValidationResultItem | null>(initialResult);
  const [isValidating, setIsValidating] = useState(false);

  const validate = useCallback(async (request: ValidateAddressRequest): Promise<AddressValidationResultItem> => {
    setIsValidating(true);
    try {
      const result = await validateAddress(request);
      if (result === null) {
        setValidationResult(networkErrorResult);
        return networkErrorResult;
      }
      setValidationResult(result);
      return result;
    } catch {
      setValidationResult(networkErrorResult);
      return networkErrorResult;
    } finally {
      setIsValidating(false);
    }
  }, []);

  const clearValidation = useCallback(() => setValidationResult(null), []);

  return { validationResult, isValidating, validate, clearValidation };
};
